export const auth = {
  authHomeTitle: 'Iniziamo',
  authHomeButtonBranded: 'Continua con E-mail',
  authHomeButtonApple: 'Continua con Apple',
  authHomeButtonGoogle: 'Continua con Google',
  authHomeButtonFacebook: 'Continua con Facebook',
  authHomeButtonLinkedin: 'Continua con LinkedIn',
  authStartTitle: 'Accedi o Registrati',
  authStartInputTitle: 'E-mail',
  authStartInputTitleError: 'Inserisci un indirizzo e-mail valido!',
  authStartInputPasswordError: 'Inserisci una password valida!',
  authWhoops: 'Ops!',
  authStartConfirmButton: 'Continua',
  authRegisteredTitle: 'Bentornato!',
  authStartPlaceholderTitle: 'E-mail',
  authRegisteredInputTitle: 'Password',
  authRegisteredForgotPassword: 'Password dimenticata',
  authAlertIncorrectPassword: 'La tua E-mail o Password non è corretta',
  authAlertRequiredPassword: 'Inserisci una password valida',
  authFinishSignUpTitle: 'Completa la Registrazione',
  authFinishSignUpEmailInputTitle: 'E-mail',
  authFinishSignUpFirstNameInputTitle: 'Nome',
  authFinishSignUpLastNameInputTitle: 'Cognome',
  authFinishSignUpPasswordInputTitle: 'Password',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">Ti consigliamo di utilizzare:</li><li class="list-disc">Almeno 8 caratteri</li><li class="list-disc">Includere 1 numero</li><li class="list-disc">Includere 1 simbolo speciale</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'Cliccando su Registrati accetti la nostra',
    privacyPolicy: 'Informativa sulla privacy',
    text2: 'e',
    termsOfUse: 'Termini di utilizzo'
  },
  authFinishSignUpConfirmButton: 'Registrati',
  authFinishSignUpErrorFirstName: 'Il Nome non può essere vuoto!',
  authFinishSignUpErrorLastName: 'Il Cognome non può essere vuoto!',
  authFinishSignUpErrorPassword: 'La Password è troppo corta!',
  authEmailConfirmationTitle: 'Controlla la tua casella di posta',
  authEmailConfirmationContent:
    "Abbiamo inviato un'e-mail di conferma per verificare il tuo indirizzo e-mail. Assicurati di controllare anche la cartella spam se non lo trovi nella tua casella di posta in arrivo.",
  authEmailConfirmationConfirmButton: 'Torna al Login',
  authAlertEmailConfirmation: 'Controlla la tua casella di posta per confermare la tua e-mail!',
  authResetPasswordTitle: 'Controlla la tua casella di posta',
  authResetPasswordDescription:
    'Abbiamo inviato un link per il ripristino della password alla tua e-mail. Assicurati di controllare anche la cartella spam se non lo trovi nella tua casella di posta in arrivo.',
  authResetPasswordButton: 'Torna al login',
  authNewPasswordTitle: 'Inserisci una nuova password',
  authNewPasswordInputTitle: 'Nuova password',
  authNewPasswordButton: 'Ripristina password',
  authNewPasswordAlertValidation: 'La tua password non è abbastanza sicura',
  authPasswordChangeSuccessTitle: 'Password cambiata!',
  authPasswordChangeSuccessContent: 'La tua password è stata cambiata con successo!',
  authPasswordChangeSuccessButton: 'Torna al login',
  authPasswordChangeErrorTitle: 'Errore!',
  authPasswordChangeErrorContent: 'Si è verificato un errore nel tentativo di reimpostare la tua password! Riprova più tardi.',
  authPasswordChangeErrorButton: 'Torna al Login',
  authInvitationTitle: 'Scegli una password',
  authInvitationInputTitle: 'Password',
  authInvitationButton: 'Imposta password',
  authEmailAddressConfirmed: 'Indirizzo e-mail confermato!'
}
